import { CommonModule } from '@angular/common'
import { Compiler, Component, ComponentRef, EventEmitter, Injector, Input, NgModule, NgModuleRef, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core'
import { FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors } from '@angular/forms'
import { MatTableDataSource } from '@angular/material'
import { RouterModule } from '@angular/router'
import * as _ from 'lodash'
import { MaterialModule } from '../../../material.module'
import { DialogService, UtilitaryService } from '../../../services'
import { FormAtylBase } from '../../form-atyl-base'
import { FormAtylControlService } from '../../form-atyl-control.service'
import { FormAtylService } from '../../form-atyl.service'
import { FormDialogErrorsComponent } from '../form-dialog/form-dialog-errors/form-dialog-errors.component'
import { TableAtylDisplayModule } from '../form-table-atyl-display/table-atyl-display.module'
import { SubFormAtylInputModule } from '../sub-form-atyl-input/sub-form-atyl-input'



@Component({
	selector: 'app-sub-form-atyl',
	templateUrl: './sub-form-atyl.component.html',
	styleUrls: ['./sub-form-atyl.component.css'],
	providers: [FormAtylControlService, FormAtylService]
})
export class SubFormAtylComponent implements OnInit {
	@ViewChild('atylSubMoteur', { read: ViewContainerRef, static: false }) atylMoteur: ViewContainerRef

	@Input() atylComponents: string
	@Input() atylTemplate: any
	@Input() atylDocuments: string
	@Input() submited = new EventEmitter<any>();
	@Input() isEditable: boolean

	@Output() loaded = new EventEmitter<boolean>();
	@Output() submit = new EventEmitter<any>();

	onsubmited: boolean = false;
	submitedSuccess: boolean = false;

	files: any = [];
	atylInputsControls: FormAtylBase<any>[]
	form: FormGroup = new FormGroup({});
	controls: any[] = [];
	payLoad = '';
	cmpRef: ComponentRef<any>
	navigation: any[] = [];
	error: string


	data: any[] = [];

	dataSource = new MatTableDataSource();
	constructor(private acs: FormAtylControlService,
		private formAtylService: FormAtylService,
		private compiler: Compiler,
		private injector: Injector,
		private moduleRef: NgModuleRef<any>,
		private dialogService: DialogService,
		private utilities: UtilitaryService) { }

	ngOnInit() {
		this.loaded.emit(false)
		this.atylInputsControls = this.formAtylService.getAtylInputs(this.atylComponents
		 )
		this.form = this.acs.toFormGroup(this.atylInputsControls)

		if (this.atylTemplate && this.atylInputsControls)
			this.createComponentFromRaw(this.atylTemplate, this.atylInputsControls, this.form)
		else if (!this.atylTemplate && !this.atylInputsControls)
			this.error = `Aucun champs ni template ont été trouvé, veuillez générer le formulaire par l'interface d'admin.`
		else if (!this.atylTemplate)
			this.error = `Aucun template de formulaire n'a été trouvé, veuillez en générer un.`
		else if (!this.atylInputsControls)
			this.error = `Aucun champs de formulaire n'a été trouvé, veuillez en créer les champs correspondant au template.`
		this.onValueChanges()
	}

	onValueChanges(): void {
		this.form.valueChanges.subscribe((val) => {
			this.submit.emit(this.form.getRawValue())
		})
	}


	ngAfterViewInit() {

	}

	private createComponentFromRaw(template: string, atylInputsToPass: FormAtylBase<any>[], formToPass: FormGroup) {

		// Let's say your template looks like `<h2><some-component [data]='data'></some-component>`
		// As you see, it has an (existing) angular component `some-component` and it injects it [data]

		// Now we create a new component. It has that template, and we can even give it data.

		const tmpCmp = Component({ template })(class {
			// the class is anonymous. But it's a quite regular angular class. You could add @Inputs,
			// @Outputs, inject stuff etc.
			atylInputsControls: FormAtylBase<any>[]
			form: FormGroup
			component: any
			constructor() {
				this.atylInputsControls = atylInputsToPass
				this.form = formToPass
			}

			ngOnInit() { /* do stuff here in the dynamic component */ }

			filterListComponent(listComponents: FormAtylBase<any>[], value: string): any {
				listComponents.forEach((component, index) => {
					if (component && component.ID === value)
						this.component = component
				})
				return this.component
			}
		})

		// Now, also create a dynamic module.
		const tmpModule = NgModule({
			imports: [
				CommonModule,
				RouterModule,
				ReactiveFormsModule,
				FormsModule,
				MaterialModule,
				TableAtylDisplayModule,
				SubFormAtylInputModule],
			declarations: [
				tmpCmp],
			entryComponents: [
			]
			// providers: [] - e.g. if your dynamic component needs any service, provide it here.
		})(class { })


		// Now compile this module and component, and inject it into that #atylMoteur in your current component template.
		this.compiler.compileModuleAndAllComponentsAsync(tmpModule)
			.then((factories) => {
				const f = factories.componentFactories[factories.componentFactories.length - 1]
				this.cmpRef = f.create(this.injector, [], null, this.moduleRef)
				this.cmpRef.instance.name = 'dynamic-form-atyl'
				this.atylMoteur.insert(this.cmpRef.hostView)
				this.loaded.emit(true)
				_.forEach(document.getElementsByTagName('mat-card'), (element, index) => {
					this.navigation.push({
						id: element.id,
						label: element.getElementsByTagName('mat-card-title')[0].innerHTML
					})
				})

			})
	}

	// Cleanup properly. You can add more cleanup-related stuff here.
	ngOnDestroy() {
		if (this.cmpRef) {
			this.cmpRef.destroy()
		}
	}
	onSubmit(btn: any) {
		btn.disabled = true
		let formformated = this.form.getRawValue()
		if (this.form.invalid) {
			this.utilities.log(this.form.errors)
			this.dialogService.open(FormDialogErrorsComponent, {
				data: this.getFormValidationErrors(this.form.controls),
			})
		}
		else {
			formformated['NOWORKFLOW'] = true
			this.submit.emit(formformated)
			this.onsubmited = true
			this.utilities.log(JSON.stringify(this.form.getRawValue()))
			btn.disabled = false
		}
	}

	onSubmited(item) {
		this.submitedSuccess = false
		if (item.hasOwnProperty('error') && item.error.hasOwnProperty('data'))
			this.payLoad = item.error.data

		if (item.hasOwnProperty('result') && item.result.hasOwnProperty('message')) {
			this.payLoad = item.result.message
			this.submitedSuccess = true
		}
	}

	scrollToCard(id) {
		document.getElementById(id).scrollIntoView()
		document.getElementsByTagName('html')[0].scrollTop -= 125
	}
	getFormValidationErrors(controls: any, container?: any): any[] {
		let errors: any[] = []
		Object.keys(controls).forEach(key => {
			const control = controls[key] as FormGroup
			controls[key].markAsTouched()
			if (control instanceof FormGroup) {
				errors = errors.concat(this.getFormValidationErrors(control.controls, key))
			}
			const controlErrors: ValidationErrors = controls[key].errors
			if (controlErrors !== null) {
				let label = ''
				_.forEach(this.atylInputsControls, (comp, index) => {
					if (comp.ID == key)
						label = comp.placeholder ? comp.placeholder : comp.label
					if (container) {
						if (container == comp.ID && comp.options.hasOwnProperty(key))
							label = comp.placeholder ? comp.placeholder : comp.label
						if (container == comp.ID && comp.type == key)
							label = comp.placeholder ? comp.placeholder : comp.label
					}
				})
				Object.keys(controlErrors).forEach(keyError => {
					errors.push({
						control_name: label,
						error_name: this.errorInputHandler(keyError),
						error_value: controlErrors[keyError]
					})
				})
			}
		})
		return errors
	}
	errorInputHandler(errorname: string) {
		switch (errorname) {
			case 'required':
				return 'requis'
		}
	}
}
